// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"BlogVideo_videoContainer__DqmTB"};